import { getEnvValue } from '@env/getEnvValue'

const cookiesEnv = {
  NEXT_PUBLIC_COOKIE_DOMAIN: getEnvValue(process.env.NEXT_PUBLIC_COOKIE_DOMAIN),
  NEXT_PUBLIC_COOKIE_POLICY_URL: getEnvValue(process.env.NEXT_PUBLIC_COOKIE_POLICY_URL),
  NEXT_PUBLIC_ALLOW_COOKIE_KEY: getEnvValue(process.env.NEXT_PUBLIC_ALLOW_COOKIE_KEY),
  NEXT_PUBLIC_ASAAS_DISTINCT_ID_COOKIE: getEnvValue(process.env.NEXT_PUBLIC_ASAAS_DISTINCT_ID_COOKIE),
  NEXT_PUBLIC_BROWSER_ID_COOKIE: getEnvValue(process.env.NEXT_PUBLIC_BROWSER_ID_COOKIE),
  NEXT_PUBLIC_USER_COOKIE: getEnvValue(process.env.NEXT_PUBLIC_USER_COOKIE),
  NEXT_PUBLIC_UTM_SOURCE_COOKIE: getEnvValue(process.env.NEXT_PUBLIC_UTM_SOURCE_COOKIE),
  NEXT_PUBLIC_CUSTOMER_LOGGED: getEnvValue(process.env.NEXT_PUBLIC_CUSTOMER_LOGGED),
  NEXT_PUBLIC_SALES_PARTNER_COOKIE: getEnvValue(process.env.NEXT_PUBLIC_SALES_PARTNER_COOKIE),
  NEXT_PUBLIC_REFERRAL_LINK_COOKIE: getEnvValue(process.env.NEXT_PUBLIC_REFERRAL_LINK_COOKIE),
  NEXT_PUBLIC_REFERRAL_TOKEN_COOKIE: getEnvValue(process.env.NEXT_PUBLIC_REFERRAL_TOKEN_COOKIE)
}

export { cookiesEnv }
